// Mini peephole on the sealed balloon cover. Fill matches the cover underlay;
// the edge uses the same iris feather as the world hole.

import LogoLoader from '@/components/common/LogoLoader';

import { APERTURE_FEATHER } from './worldCoverAperture';

const LOADER_SIZE = 96;
const HOLE_DIAMETER = 120;
const HOLE_RADIUS = `${HOLE_DIAMETER / 2}px`;

const holeMask = `radial-gradient(circle at 50% 50%, #000 ${HOLE_RADIUS}, transparent calc(${HOLE_RADIUS} + ${APERTURE_FEATHER}))`;

const CoverLoader = () => (
  <div
    className="pointer-events-none flex items-center justify-center bg-neutral-950"
    style={{
      width: `calc(${HOLE_DIAMETER}px + 2 * ${APERTURE_FEATHER})`,
      height: `calc(${HOLE_DIAMETER}px + 2 * ${APERTURE_FEATHER})`,
      maskImage: holeMask,
      WebkitMaskImage: holeMask,
    }}
  >
    <LogoLoader size={LOADER_SIZE} />
  </div>
);

export default CoverLoader;
